import { generateWords } from '../../../utils/generate'

export const TEXTAREAS_ERROR_TEXT = 'Error message replaces helper text'

export const TEXTAREAS_HELP_TEXT = 'Help text goes here'

export const TEXTAREAS_INFO = generateWords(10)

export const TEXTAREAS_LABEL = 'Label'

export const TEXTAREAS_MAX_LENGTH = 256

export const TEXTAREAS_MIN_ROWS = 3

export const TEXTAREAS_PLACEHOLDER = 'Placeholder'

export const TEXTAREAS_VALUE = generateWords(10)
